import React, { useState } from "react";
import { Button, Form, Input, Space, message } from "antd";
import { ArrowLeftOutlined, MobileOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import ResetPassForm from "./resetPass";
function ForgetPassword({ back }) {
  const [error, setError] = useState("");
  const [mobile, setMobile] = useState(false);
  const [smsExpiresAt, setSmsExpiresAt] = useState(false);

  const FORGETPASSWORD = gql`
    mutation authReset1($authReset1Input: AuthReset1Input!) {
      authReset1(authReset1Input: $authReset1Input) {
        expiresAt
      }
    }
  `;

  const [runAuthReset1, authReset1] = useMutation(FORGETPASSWORD, {
    onCompleted(data) {
      const smsExpiresAt = moment().diff(data?.authReset1?.expiresAt, "minute")
      setSmsExpiresAt(Math.abs(smsExpiresAt));
      message.info(`کد یکبار مصرف به شماره ${mobile} ارسال شد.`);
    },
    onError(error) {
      setError(error.message);
    },
  });
  const doAuthReset1 = (authReset1Input) => {
    runAuthReset1({
      variables: {
        authReset1Input,
      },
    });
  };
  if (!smsExpiresAt)
    return (
      <div>
        <Form
          name="normal_login"
          className="login-form"
          onFinish={doAuthReset1}
        >
          <Form.Item
            name="mobile"
            style={{ marginBottom: "30px" }}
            rules={[
              {
                required: true,
                message: "لطفا شماره همراه خود را وارد کنید!",
              },
              {
                pattern: /^09[0-9]{9}$/,
                message: "فرمت موبایل صحیح نیست!"
              }
            ]}
            validateStatus={error && "error"}
            help={error}
          >
            <Input
              size="large"
              className="form-input"
              prefix={<MobileOutlined className="site-form-item-icon" />}
              placeholder="شماره همراه"
              onChange={(e) => setMobile(e.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={authReset1.loading && true}
              >
                ارسال کد
              </Button>
              <Button type="link" icon={<ArrowLeftOutlined />} onClick={back}>
                بازگشت
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    );
  return (
    <ResetPassForm
      mobile={mobile}
      resend={() => setSmsExpiresAt(false)}
      smsExpiresAt={smsExpiresAt}
    />
  );
}

export default ForgetPassword;
